import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import { GetProfileVisibilityOptionsDocument } from 'src/types/graphql';

export const useProfileVisibilityOptions = () => {
  const { language, locale, zone } = useAppConfig();
  const languageLocale = `${language}-${locale}`;
  const { data, loading, error } = useQuery(
    GetProfileVisibilityOptionsDocument,
    {
      variables: {
        locale: languageLocale,
        zone,
      },
    },
  );
  const profileVisibilityOptions = data?.profileVisibilityOptions;

  return {
    profileVisibilityOptions,
    loading,
    error,
  };
};
